import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["IconDelete22x22"] || "IconDelete22x22"} xmlns="http://www.w3.org/2000/svg" width="22" height="22" {...props}><g fill="none" fillRule="evenodd"><circle cx="11" cy="11" r="11" fill="#DFE1E6" /><path fill="#FFF" d="M14.167 7l.833.833L11.833 11 15 14.167l-.833.833L11 11.833 7.833 15 7 14.167 10.166 11 7 7.833 7.833 7 11 10.166 14.167 7z" /></g></svg>);